import { AvailableModules } from 'generated/featureDefinitions'
import {
  GetTasksDocument,
  HasSurveysEnabledDocument,
  MaterializedProcessQuery,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

type ProcessesMaterializedItem = NonNullable<
  NonNullable<
    MaterializedProcessQuery['processes']['materializedProcessesConnection']['nodes'][number]
  >['materializedSteps'][number]['materializedItems'][number]
>

interface Props {
  assigneeId: string
  ids: string[]
  skip?: boolean
  materializedItems: ProcessesMaterializedItem[]
}

export const useHasSurveys = () => {
  const { data: dataSurveys, loading } = useQuery(HasSurveysEnabledDocument, {
    variables: {
      moduleIds: [AvailableModules.surveys],
    },
  })

  const enabled = dataSurveys?.companies?.moduleAvailabilities[0]?.available

  return {
    loading,
    enabled,
  }
}

export const useGetTasksProcess = ({ assigneeId, ids, materializedItems, skip = false }: Props) => {
  const { data: dataTasks, loading } = useQuery(GetTasksDocument, {
    skip: skip,
    variables: {
      ids,
      assigneeId,
    },
  })

  const tasks = dataTasks?.tasks.tasks.map((task) => {
    const materializedItem = materializedItems?.find((item) => item.resourceId === task.id)

    return { ...task, mandatory: !!materializedItem?.item?.taskConfiguration?.mandatory }
  })

  return {
    loading,
    tasks,
  }
}
